import request from '@/require/axios.js'

export const api = {
  async get(url, data) {
    try {
      let res = await request.get(url, {
        params: data
      }, {
        headers: {
          'Content-Type': "text/html;charset=utf8"
        }
      })
      res = res.data
      // if (res.code === 0) {
      //    success(res)
      //     } 
      return new Promise((resolve) => {
        if (res.code === 0) {
          resolve(res)
        } else {
          resolve(res)
        }
      })
    } catch (err) {
      // alert('服务器出错')
      console.log(err)
    }
  },
  async post(url, data) {
    try {
      let res = await request.post(url, data)
      res = res.data
      return new Promise((resolve, reject) => {
        if (res.code === 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
    } catch (err) {
      // alert('服务器出错')
      console.log(err)
    }
  }
}